var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "28px",
    viewBox: "0 0 21 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/amenities/restaurant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/amenities/restaurant",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "restaurant-fork-knife",
    stroke: "#333333",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.37383333,
    y1: 0.875,
    x2: 4.37383333,
    y2: 27.125,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87383333,0.875 L7.87383333,8.75 C7.86806743,10.6806033 6.3044366,12.2442341 4.37383333,12.25 C2.44323007,12.2442341 0.879599235,10.6806033 0.873833333,8.75 L0.873833333,0.875",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8738333,18.375 L18.3738333,18.375 C18.843216,18.392882 19.2988009,18.2142565 19.6309454,17.882112 C19.9630898,17.5499676 20.1417154,17.0943827 20.1238333,16.625 C19.936,11.599 19.733,6.335 16.492,1.27516667 C16.2786582,0.950137124 15.8776529,0.803138114 15.5047882,0.913278261 C15.1319236,1.02341841 14.8751559,1.36471634 14.8726667,1.7535 L14.8726667,27.125",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.d5d5f69f8c190b1636254b13e829d90f.svg";
export { ForwardRef as ReactComponent };